import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import Home from "@/pages/Home";
import Posters from "@/pages/Posters";
import About, { Footer } from "@/pages/About";
import Quiz from "@/pages/Quiz";
import ElementIndex from "@/pages/ElementIndex";
import SymptomSearch from "@/pages/SymptomSearch";
import OccupationalDiseases from "@/pages/OccupationalDiseases";
import DiseaseSearch from "@/pages/DiseaseSearch";
import FirstAidKit from "@/pages/FirstAidKit";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/index" element={<ElementIndex />} />
          <Route path="/symptoms" element={<SymptomSearch />} />
          <Route path="/diseases" element={<OccupationalDiseases />} />
          <Route path="/disease-search" element={<DiseaseSearch />} />
          <Route path="/first-aid-kit" element={<FirstAidKit />} />
          <Route path="/quiz" element={<Quiz />} />
          <Route path="/posters" element={<Posters />} />
          <Route path="/about" element={<About />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
